export const DROPS_ANALYTIC_EVENTS = {
    PUBLISH_DROP: 'publish_drop',
    SAVE_DROP: 'save_drop',
    PREVIEW_DROP: 'preview_drop',
    DROP_FORM_STEP_CHANGE: 'drop_form_step_change',
    DROP_DARE_FILTERS: 'drop_dare_filters',
};
